// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { INVOICE_ACTIONS, SECONDARY_ACTIONS_MAPPING } from '../../../consts/consts';
import {
  isInvoiceStatusCancelled,
  isInvoiceStatusPaid,
  isInvoiceStatusSent,
  isInvoiceStatusUnsent,
} from '../../../utils';
import { HUB_MODALS } from '../../InvoiceHubModals';
import { useStore } from '../../../../../../store';

export const SecondaryInvoiceActions = ({ status } : { status: string }) => {
  const setActiveModal = useStore(state => state.setActiveModal);
  const { t } = useTranslation();
  const iconsList = useMemo(() => {
    if (isInvoiceStatusSent(status)) return SECONDARY_ACTIONS_MAPPING.SENT;
    if (isInvoiceStatusUnsent(status)) return SECONDARY_ACTIONS_MAPPING.UNSENT;
    if (isInvoiceStatusPaid(status)) return SECONDARY_ACTIONS_MAPPING.PAID;
    if (isInvoiceStatusCancelled(status)) return SECONDARY_ACTIONS_MAPPING.CANCELED;
    return null;
  }, [status]);
  if (!iconsList) return null;
  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, name: string) => {
    if (name === INVOICE_ACTIONS.SHARE_LINK) setActiveModal(HUB_MODALS.SHARE_LINK);
    if (name === INVOICE_ACTIONS.CANCEL) setActiveModal(HUB_MODALS.CANCEL_INVOICE);
  };
  return (
    <div className='flex'>
      <div className='flex items-center'>
        {iconsList.map((icon) => (
          <button type='button' onClick={(e) => onClick(e, icon?.name)} key={icon.key} className='w-[40px] h-[34px] items-center justify-center hover:bg-bw03 hover:rounded flex hover:cursor-pointer' data-tooltip-id='invoice-actions-tooltip' data-tooltip-content={`${t(icon.title)}`}>
            <icon.SVGIcon className='stroke-bw07' />
          </button>
        ))}
      </div>
    </div>
  );
};
